import { useContext } from 'react';
import {
  CurrentUserContext,
  NotificationContextType,
} from '@/context/CurrentUserContext';

export default (): NotificationContextType => useContext(CurrentUserContext);
